module.exports = __webpack_public_path__ + "img/type2_uncheck.424434fe.png";